import { useState } from "react";
import { Link } from "react-router-dom";
import authService from "../../auth/authService";
import { VscThreeBars } from "react-icons/vsc";
import { MdDashboard } from "react-icons/md";
import { MdOutlineAddchart } from "react-icons/md";
import { GrArticle } from "react-icons/gr";
import { IoIosLogOut } from "react-icons/io";
import { FaRocketchat } from "react-icons/fa";
import { IoIosChatboxes } from "react-icons/io";
import { ArrowLeftRight, Users } from "lucide-react";

const SideBar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleLogOut = () => {
    authService.logout();
  };

  const toggleSidebar = () => {
    setIsCollapsed((prevState) => !prevState);
  };

  return (
    <div
      className={`d-flex flex-column flex-shrink-0 p-3 text-white sidebar ${
        isCollapsed ? "collapsed" : ""
      }`}
      style={{ backgroundColor: "#1d3256" }}
    >
      <div className="d-flex justify-content-between">
        <div className="d-flex justify-content-between align-items-center">
          <div
            onClick={toggleSidebar}
            className="d-flex align-items-center text-white text-decoration-none hover-opacity"
          >
            <div
              className="d-flex align-items-center justify-content-center me-3 rounded shadow-sm"
              style={{
                width: "32px",
                height: "32px",
                background:
                  "linear-gradient(to bottom right, #60a5fa, #8b5cf6)",
              }}
            >
              <div
                className="d-grid"
                style={{ gridTemplateColumns: "repeat(2, 1fr)", gap: "2px" }}
              >
                <div
                  className="bg-white rounded opacity-90"
                  style={{ width: "6px", height: "6px" }}
                />
                <div
                  className="bg-white rounded opacity-70"
                  style={{ width: "6px", height: "6px" }}
                />
                <div
                  className="bg-white rounded opacity-70"
                  style={{ width: "6px", height: "6px" }}
                />
                <div
                  className="bg-white rounded opacity-90"
                  style={{ width: "6px", height: "6px" }}
                />
              </div>
            </div>
            {!isCollapsed && (
              <Link to="/client/dashboard" style={{ textDecoration: "none" }}>
                <div className="d-flex flex-column">
                  <span className="fw-semibold text-white">Account Panel</span>
                  <div
                    className={`d-flex align-items-center gap-1 small fw-medium text-success`}
                  >
                    <Users className="h-3 w-3" />
                    <span className="text-capitalize">Client</span>
                  </div>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>

      <hr />
      <ul className="nav nav-pills flex-column mb-auto">
        <li className="nav-item">
          <Link
            to="/client/dashboard"
            className="nav-link text-white"
            aria-current="page"
          >
            <MdDashboard className="me-2" />
            {!isCollapsed && "Dashboard"}
          </Link>
        </li>
        <li>
          <Link to="/client/submit-article" className="nav-link text-white">
            <MdOutlineAddchart className="me-2" />
            {!isCollapsed && "Submit Invoice"}
          </Link>
        </li>
        <li>
          <Link to="/client/submit-adjustment" className="nav-link text-white">
            <ArrowLeftRight className="me-2" size={16} />
            {!isCollapsed && "Adjustment"}
          </Link>
        </li>
        <li>
          <Link to="/client/Articles" className="nav-link text-white">
            <GrArticle className="me-2" />
            {!isCollapsed && "My Invoice"}
          </Link>
        </li>

        <li>
          <Link to="#" className="nav-link text-white" onClick={handleLogOut}>
            <IoIosLogOut className="me-2" />
            {!isCollapsed && "Log out"}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SideBar;
